import { Component, EventEmitter, Input, Output } from '@angular/core';

import { SlLinkComponent } from '../../sl-link/sl-link.component';
import { SlButtonComponent } from '../../sl-button/sl-button.component';

type variantType = 'primary' | 'secondary' | 'tertiary';
type colors = 'basic' | 'danger';
@Component({
  selector: 'sl-modal-footer',
  standalone: true,
  imports: [SlLinkComponent, SlButtonComponent],
  templateUrl: './sl-modal-footer.component.html',
  styleUrl: './sl-modal-footer.component.scss',
})
export class SlModalFooterComponent {
  @Input() linkText?: string;
  @Input() linkPath?: string;
  @Input() secondaryButton?: {
    text: string;
    variant?: variantType;
    icon?: string;
    color?: colors;
  };
  @Input() primaryButton!: {
    text: string;
    variant?: variantType;
    icon?: string;
    color?: colors;
  };
  @Input() tertiaryButton?: {
    text: string;
    variant?: variantType;
    icon?: string;
    color?: colors;
  };
  @Input() formId?: string;

  @Output() primaryButtonEvent: EventEmitter<void> = new EventEmitter<void>();
  @Output() secondaryButtonEvent: EventEmitter<void> = new EventEmitter<void>();
  @Output() tertiaryButtonEvent: EventEmitter<void> = new EventEmitter<void>();

  onClickPrimaryButton(): void {
    this.primaryButtonEvent.emit();
  }

  onClickSecondaryButton(): void {
    this.secondaryButtonEvent.emit();
  }

  onClickTertiaryButton(): void {
    this.tertiaryButtonEvent.emit();
  }

  onClickTextLink(): void {
    window.open(this.linkPath, '_blank');
  }
}
